import React, { useState, useEffect } from "react"
import styled from "styled-components"
import bellyDesktop1 from "images/ads/Chevron_TCC22_Website_970x250.jpg"
import bellyTablet1 from "images/ads/Chevron_TCC22_Website_728x90.jpg"
import bellyMobile1 from "images/ads/Chevron_TCC22_Website_320x50.jpg"
// import bellyDesktop2 from "images/ads/ANA22-digital-banner-ad-970x250.jpg"
// import bellyTablet2 from "images/ads/ANA22-digital-banner-ad-728x90.jpg"
// import bellyMobile2 from "images/ads/ANA22-digital-banner-ad-320x50.jpg"

const AdWrap = styled.div`
	background-color: white;

	.ad {
		display: flex;
		justify-content: center;
	}
`

const BellyBandTemp = () => {
  const [ad, setAd] = useState(0)
  const ads = [
    {
      desktop: bellyDesktop1,
      tablet: bellyTablet1,
      mobile: bellyMobile1,
      url: "https://www.chevron.com"
    }
  ]

  useEffect(() => {
    const interval = setInterval(() => {
      const max = ads.length - 1
      setAd(ad => ad + 1 > max ? 0 : ad + 1)
    }, 10000);

    return () => clearInterval(interval);
  }, [])

  return(
    <AdWrap className="pb-2" style={{ marginLeft: "-15px" }}>
      <a href={ads[ad].url} target="_blank" rel="noopener noreferrer" className="ad">
        <img src={ads[ad].desktop} alt="" className="d-none d-lg-block" />
        <img src={ads[ad].tablet} alt="" className="d-none d-md-block d-lg-none" />
        <img src={ads[ad].mobile} alt="" className="d-md-none" />
      </a>
    </AdWrap>
  )
}

export default BellyBandTemp